import React from "react";
import * as PropTypes from "prop-types";
import {useQuery} from "@tanstack/react-query";
import {Alert} from "@mui/material";
import Spinner from "../Spinner/Spinner";


export default function FetchLoaderForOneResourceUrl({children, resource}) {

    const {data = {}, isLoading, isError} = useQuery({
        queryKey: ['data'],
        queryFn: () => fetch(resource).then((res) => res.json())
    })

    if (isLoading) return <Spinner/>

    if (data.hasOwnProperty('message') || isError) {
        return <Alert severity="error">Wystąpił błąd, nie można obecnie pobrać tabeli raportów.</Alert>
    }

    return React.Children.map(children, (child) => {
        // Checking isValidElement is the safe way and avoids a typescript error too.
        if (React.isValidElement(child)) {
            return (
                React.cloneElement(child, {data})
            );
        }
        return (
            child
        );
    });
}

FetchLoaderForOneResourceUrl.propTypes = {children: PropTypes.node};
